import Input from "./Input";

export default class InputText extends Input { }